import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { CURRENCIES, useCurrencyStore, type SupportedCurrency } from "@/lib/currency";

export const CurrencySwitcher = ({ compact = false }: { compact?: boolean }) => {
  const currency = useCurrencyStore((s) => s.currency);
  const setCurrency = useCurrencyStore((s) => s.setCurrency);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={compact ? "h-8 px-2 text-xs gap-1" : "h-8 gap-1"}
          aria-label={`Currency: ${currency}`}
        >
          <span aria-hidden>{CURRENCIES[currency].flag}</span>
          <span>{currency}</span>
          <ChevronDown className="h-3 w-3 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        {(Object.keys(CURRENCIES) as SupportedCurrency[]).map((c) => (
          <DropdownMenuItem
            key={c}
            onSelect={() => setCurrency(c, true)}
            className={currency === c ? "font-medium" : ""}
          >
            <span className="mr-2">{CURRENCIES[c].flag}</span>
            <span className="flex-1">{CURRENCIES[c].label}</span>
            <span className="text-xs text-muted-foreground ml-2">{c}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
